import { Controller } from "@hotwired/stimulus"
import RequestHelper from "../helpers/request_helper"

export default class extends Controller {
  static get targets() { return ["products"]; }
  static get values() { return { url: String }; }

  load(event) {
    const url = new URL(this.urlValue, window.location.origin);
    url.searchParams.set("supplier_id", event.target.value);

    const options = RequestHelper.defaultRequestOptions();
    // The action serves the product partial only to request.xhr?, and renders the whole page
    // otherwise. $http set this header; fetch does not.
    options.headers = Object.assign({}, options.headers, { "X-Requested-With": "XMLHttpRequest" });

    fetch(url, options).
      then(response => {
        if (!response.ok) { throw new Error(`Product lookup failed (${response.status})`); }
        return response.text();
      }).
      // urlValue is always same-origin (it is set from a Rails path helper in the view, resolved
      // against window.location.origin above), so this is server-rendered HTML from our own
      // origin, not user input or third-party content.
      then(html => { this.productsTarget.innerHTML = html; }).
      catch(this.logFailedCall);
  }

  logFailedCall(response) {
    console.warn(response);
  }
}
